import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withControlErrorHandling, withControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { withCustomValidation, } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { DefaultBid } from './default-bid';

const DefaultBidWithValidation = withControlErrorHandling(withControlErrors(DefaultBid));

const DefaultBidWithWaring = (props) => {
  const {
    updateValidation, validationProps, onBidChange,
    ...rest
  } = props;

  const activity = useContext(ActivityContext);

  const onCountValidate = useCallback((result) => {
    const { messages = [], data } = result;
    const fieldValue = data[validationProps.field];
    if (fieldValue !== validationProps.data[validationProps.field]) {
      updateValidation(messages, data);
    }

    if (onBidChange) {
      onBidChange(fieldValue, result);
    }

    if (activity) {
      activity.signal(`onDefaultBidChanged - ${validationProps.field}: ${data[validationProps.field]}`);
    }
  }, [activity, updateValidation, validationProps.data, validationProps.field]);

  return (
    <>
      <DefaultBidWithValidation
        {...rest}
        validationProps={{
        ...validationProps,
        onValidate: onCountValidate,
      }}
      />
    </>
  );
};

DefaultBidWithWaring.propTypes = {
  updateValidation: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({
    field: PropTypes.string.isRequired,
    data: PropTypes.shape({}).isRequired,
  }).isRequired,
  onBidChange: PropTypes.func,
};
DefaultBidWithWaring.defaultProps = {
  onBidChange: null,
};

export const CustomValidatedDefaultBid = withCustomValidation(DefaultBidWithWaring);
